var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBsImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    fill: "none",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#TpLVHW7Bcia)",
    d: "M297.4 343.1H289L270.3 322V126c3.5 1.4 7.2 2.2 11.2 2.2 16.1 0 29.1-13.1 29.1-29.1S297.5 70 281.5 70h-6.2l3.2-13c.4-1.8 0-3.7-1.1-5.1-1.1-1.5-2.9-2.3-4.7-2.3H156.9c-1.8 0-3.6.8-4.7 2.3s-1.6 3.3-1.1 5.1l3.2 13h-6.2c-16 0-29.1 13-29.1 29.1s13.1 29.1 29.1 29.1c3.9 0 7.7-.8 11.1-2.2v196l-18.7 21.1h-8.4c-3.3 0-6 2.7-6 6v26.7c0 3.3 2.7 6 6 6h165.2c3.3 0 6-2.7 6-6v-26.7c.1-3.3-2.6-6-5.9-6m-126.1-224h87v199.2h-87zm-6.7-57.6H265l-2.1 8.5h-96.3zM131 99.1c0-9.4 7.7-17.1 17.1-17.1h133.4c9.5 0 17.1 7.7 17.1 17.1s-7.7 17.1-17.1 17.1-17.1-7.7-17.1-17.1c0-3.3-2.7-6-6-6s-6 2.7-6 6c0 2.8.4 5.5 1.1 8h-77.4c.7-2.5 1.1-5.2 1.1-8 0-3.3-2.7-6-6-6s-6 2.7-6 6c0 9.4-7.7 17.1-17.1 17.1S131 108.5 131 99.1m37 231.2h93.6l11.3 12.8H156.6zm123.4 39.5H138.2v-14.7h153.2zm-70.6-180.9v106.8c0 3.3-2.7 6-6 6s-6-2.7-6-6V188.9c0-3.3 2.7-6 6-6s6 2.7 6 6m-23 27.1v79.7c0 3.3-2.7 6-6 6s-6-2.7-6-6V216c0-3.3 2.7-6 6-6s6 2.6 6 6m46 0v79.7c0 3.3-2.7 6-6 6s-6-2.7-6-6V216c0-3.3 2.7-6 6-6s6 2.6 6 6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "TpLVHW7Bcia",
    x1: 95.3542,
    x2: 334.181,
    y1: 108.595,
    y2: 347.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#a866ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4adede"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsImg);
export default __webpack_public_path__ + "static/media/bs-img.ebe5d229d24ad36b0679760d03ca5b6e.svg";
export { ForwardRef as ReactComponent };